import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const resetPassword = async (data: any) => {
	const URL = `${API_URL}ResetPassword`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);

	if (process.env.NODE_ENV === 'development') console.log('Request payload (encrypted):', data);
	const requestData = {
		ResetPasswordToken: data, // Use capital R and P to match backend expectation
	};
	return makeApiCall(URL, requestData);
};

export const resetFingerprint = async (data: any) => {
	const URL = `${API_URL}ResetDeviceFingerprint`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);

	if (process.env.NODE_ENV === 'development') console.log('Request payload (encrypted):', data);
	const requestData = {
		ResetDeviceFingerprintToken: data, // Use correct key name to match backend expectation
	};
	return makeApiCall(URL, requestData);
};
